import React from 'react';
import { categoryIcon } from './api';

// A rubber stamp (handle pressing onto paper) — there's no stamp emoji, so the
// kosher-certification category renders this inline SVG instead. Sized in `em`
// so it scales to the surrounding font size exactly like the emoji it replaces.
export function StampIcon({ size }) {
  const dim = size || '1em';
  return (
    <svg
      width={dim} height={dim} viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"
      style={{ display: 'inline-block', verticalAlign: '-0.125em' }}
    >
      {/* handle + body of the stamp */}
      <path d="M15 8.6c0-1 .3-1.6.8-2.3.7-.9.7-2-.1-2.9a3 3 0 0 0-4.4 0c-.8.9-.8 2-.1 2.9.5.7.8 1.3.8 2.3V9H8.5A2.5 2.5 0 0 0 6 11.5V13h12v-1.5A2.5 2.5 0 0 0 15.5 9H15v-.4z" />
      {/* the paper line it stamps onto */}
      <rect x="4" y="18.4" width="16" height="2.2" rx="1.1" />
    </svg>
  );
}

// Drop-in for `{categoryIcon[type] || '📍'}` in JSX contexts.
export default function CategoryIcon({ type }) {
  if (type === 'kosher_certification_hechsher') return <StampIcon />;
  return <>{categoryIcon[type] || '📍'}</>;
}

// Same stamp as an HTML string, for non-React contexts (e.g. Leaflet map-pin
// divIcons). Kept in sync with StampIcon above.
export function stampSvgHtml(size = '1em', color = 'currentColor') {
  return `<svg width="${size}" height="${size}" viewBox="0 0 24 24" fill="${color}" style="display:block;">`
    + `<path d="M15 8.6c0-1 .3-1.6.8-2.3.7-.9.7-2-.1-2.9a3 3 0 0 0-4.4 0c-.8.9-.8 2-.1 2.9.5.7.8 1.3.8 2.3V9H8.5A2.5 2.5 0 0 0 6 11.5V13h12v-1.5A2.5 2.5 0 0 0 15.5 9H15v-.4z"/>`
    + `<rect x="4" y="18.4" width="16" height="2.2" rx="1.1"/></svg>`;
}

// HTML for a category icon (stamp SVG for the cert category, else the emoji).
// `size` is the px size used for the SVG; the emoji uses the container font-size.
export function categoryIconHtml(type, sizePx, color) {
  if (type === 'kosher_certification_hechsher') return stampSvgHtml(`${sizePx}px`, color || '#1a4d8f');
  return categoryIcon[type] || '📍';
}
